import { render, staticRenderFns } from "./MachineryMakersContacts.vue?vue&type=template&id=6abd555a&"
import script from "./MachineryMakersContacts.vue?vue&type=script&lang=js&"
export * from "./MachineryMakersContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports